import { Pipe, PipeTransform } from '@angular/core';
import { isEmpty } from '@finder/shared/utils/object/isEmpty';

@Pipe({
    name: 'hasText',
    standalone: true
})
export class HasTextPipe implements PipeTransform {

    transform(value: any): unknown {
        if (isEmpty(value) || !Object.entries(value || {}).length) {
            return false;
        }

        return value.title || value.subtitle || value.text;
    }
}
